import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Calendar } from "lucide-react";
import portfolioData from "../../data/mock";

const EducationSection = () => {
  const { education } = portfolioData;

  return (
    <section id="education" className="relative py-28 bg-ink-950">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-ink-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-brand-400" />
            <span className="text-brand-400 text-sm font-medium tracking-wider uppercase">
              Education
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Academic Background
          </h2>
        </motion.div>

        <div className="space-y-6">
          {education.map((edu, index) => (
            <motion.div
              key={edu.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group p-6 sm:p-8 rounded-xl border border-ink-800/60 bg-ink-900/20 hover:border-brand-500/20 hover:bg-ink-900/40 transition-all duration-300"
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-brand-500/10 flex items-center justify-center text-brand-400">
                  <GraduationCap size={24} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-white mb-1">
                    {edu.degree}
                  </h3>
                  <p className="text-brand-400 text-sm mb-2">
                    {edu.institution}
                  </p>
                  <div className="flex items-center gap-2 text-slate-400 text-sm mb-4">
                    <Calendar size={14} />
                    <span>{edu.period}</span>
                  </div>
                  <p className="text-slate-300 text-sm leading-relaxed">
                    {edu.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
